import styled from "styled-components";

const WinesAddBottleTrayFooter = styled.div`
  text-align: center;
  padding: 0px 20px;
`;

const WinesAddBottleTrayFooterItem = styled.div`
  &:not(:first-child) {
    margin-top: 20px;
  }
  > p {
    &:not(:last-child) {
      margin-bottom: 10px;
    }
  }
`;

export { WinesAddBottleTrayFooter, WinesAddBottleTrayFooterItem };
